// import el from 'element-ui/lib/locale/lang/en' //引入element语言包

const m = {
	// message: {
		tips: 'Tips',
		cancel: 'Cancel',
		sure: ' OK ',
		search: 'Search',
		add: 'Add',
		delete: 'Delete',
		modify: 'Modify',
		back: 'Back',
		addSuccess: 'Added Successfully',
		modifySuccess: 'Modified Successfully',
		deleteSuccess: 'Deleted Successfully',
		uploadSuccess: 'Uploaded Successfully',
		sureDelete: ' Are you sure to delete?',
		chooseDelete: 'Check Contents to Delete',
		enableFlag: 'Status',
		status: 'Status', 
		enable: 'Enable',
		disable: 'Disable',
		operation: 'Operation',
		chooseDate: 'Choose Date',
		keyName: 'Key Name',
		addLine: 'Add Line',
		deleteLine: 'Delete Line',
		addColumn: 'Add Column',
		deleteColumn: 'Delete Column',
		pleaseChoose: 'Please Choose',
		exportResults: 'Export Query Results',
		chooseExpNum: 'Choose Export Segment',
		//template
		exchangeTemplate: 'Download Exchange Rates Setup Template',
		discountTemplate: 'Download Discount Rates Setup Template',
		taxRateTemplate: 'Download Tax Rates Setup Template',
		orgTemplate: 'Download Lease Organizations Setup Template',
		onlyTemplate: 'Only Template Files Can Be Uploaded',
		dataTemplate: 'Download Data Permission Setup Template',
		EPOTemplate: 'Download Lease Item Upload Template',
		leaseTemplate: 'Download Lease Item Upload Template',
		POTemplate: 'Download Reallocate PO Receipt Template',
		userTemplate: 'Download User Setup Template',
		leaseAnnotationTemplate: 'Download Lease Disclosure Appendix Template',
		chooseFile: 'Choose File',
		uploadFile: 'Upload',
		uploadErr: 'Upload Error Info',
		exportErr: 'Export Error Info',
		errOrder: 'Order',
		errDescription: 'Description',
		//字段
		primaryLedger: 'Primary Ledger',
		ouName: 'OU Name',
		costCenter: 'Cost Center',
		currency: 'Currency',
		leaseType: 'Lease Type',
		dataSource: 'Data Source',
		region: 'Region',
		leaseItemCategory: 'Lease Item Category',
		leaseTerm: 'Lease Term(Month)',
		leaseItemType: 'Lease Item Type',
		usefulLife: 'Depreciable life',
		assetBook: 'Asset Book',
		assetCategory: 'Asset Category',
		depreciationExpenseAccount: 'Depreciation Expense Account',
		contractCurrency: 'Contract Currency',
		legalEntity: 'Legal Entity',
		leaseItemNumber: 'Lease Item Number',
		transactionType: 'Transaction Type',
		poNumber: 'PO Number',
		contractNumber: 'Contract Number',
		referenceContractNumber: 'Reference Contract Number',
		contractDate: 'Contract Date',
		leaseDate: 'Lease Date',
		originalLeaseItemNumber: 'Original Lease Item Number',
		revaluationDate: 'Revaluation Date',
		uploader: 'Uploader',
		earlyTerminateFlag: 'Early Terminate Flag',
		earlyTerminateStatus: 'Early Terminate Approval Status',
		leaseItemStatus: 'Status',
		vendorName: 'Vendor Name',
		contractStartDate: 'Contract Start Date',
		contractEndDate: 'Contract End Date',
		extensionFlag: 'Extension Flag',
		leaseItemDescription: 'Lease Item Description',
		leaseStartDate: 'Lease Start Date',
		leaseEndDate: 'Lease End Date',
		purchaseRightFlag: 'Purchase Right Flag',
		shortTermExemptionFlag: 'Short Term Exemption',
		lowValueExemptionFlag: 'Low Value Exemption',
		variableExemptionFlag: 'Variable Exemption',
		earlyTerminateOa: 'Early Terminate OA Account',
		earlyTerminateChecker: 'Early Terminate Checker',
		earlyTerminateReviewer: 'Early Terminate Reviewer',
		earlyTerminateMes: 'Early Terminate Info',
		transitionOption: 'Transition Option',
		rejectComment: 'Reject Comment',
		poVarchargeAccount: 'PO Charge Account',
		extensionTerm: 'Extension Term（Month）',
		terminateFrom: 'Renwew From',
		controlDateTo: 'Control Date To',
		startRate: 'Start Rate',
		purchaseRightFlag: 'Purchase Right Flag',
		purchaseValue: 'Purchase value greater than $5000',
		leaseItemComment: 'Lease Item Comment',
		poLineNumber: 'PO Line Number',
		deliveryBatchNumber: 'Delivery Batch Number',
		referenceValue: 'Reference Value',
		annualDiscountRate: 'Annual Discount Rate',
		financeLeaseFlag: 'Finance Lease Flag',
		subleaseFlag: 'Sub Lease Flag',
		serialNumber: 'Serial Number',
		originalPoNumber: 'Original PO Number',
		originalPoLineNumber: 'Original PO Line Number',
		originalDeliveryBatchNumber: 'Original Delivery Batch Number',
		partialCancelPercentage: 'Partial Cancel Percentage',
		assetAdjAmount: 'Asset Adjust Amount',
		pandlAdj: 'Profit and Loss Adjust Amount',
		liabilityAdjUstment: 'Liability Adjustment',
		comment: 'Comment',
		modificationReason: 'Modification Reason',
		paymentDateFrom: 'Payment Date From',
		paymentDateTo: 'Payment Date To',
		leasePaymentType: 'Lease Payment Type',
		frequentFlag: 'Frequency(F/V/RF)',
		paymentFrequency: 'Payment Frequency',
		usedCount: 'Quantity',
		unitType: 'Unit of Measure',
		unitPrice: 'Unit Price',
	//	periodFlag: 'Initial / Final Payment',
        periodFlag: '期初/PayInAdvanceOR期末/PayInArrears',
		beginBalances: 'Liability Beginning Balance',
		paymentAmount: 'Payment Amount',
		interest: 'Interest',
		principal: 'Principal',
		endBalances: 'Liability Ending Balance',
		faAccountedFlag: 'Posted',
		cfAccountedFlag: 'Reclassfied',
		useright: 'Asset Beginning Balance',
		starttime: 'Asset Start Time',
		depreciation: 'Useful Life(Month)',
		usefulMethod: 'Depreciation Method',
		assetNumber: 'Asset Number',
		accountingPeriod: 'Depreciation Period',
		usefulAmount: 'Depreciation Amount',
		usefulTotalAmount: 'Acc. Depreciation',
		assetOriginalAmount: 'Asset Original Value',
		assetNetAmount: 'Asset Net Value',
		extensionRightFlag: 'Extension Right',
		closeFlag: 'Close Flag',
		orderCurrency: 'Currency',
        contract_currency: 'Contract Currency',
		//login
		chinese: 'zh',
		english: 'en',
		Lap: 'Tencent Lease Accounting Platform',
		LapStyle: 'psc-font-7',
    passExpire1: 'Your password will expire in ',
    passExpire2: ' days,please change your password soon.',
    passExpire3: 'The password is expired，please change your password.',
		forgetPwd: 'Forget Password',
        forgetPwdHelp: 'If you forget your password, please contract system admin.',
		systemLang: 'System Languag',
		inputAccount: 'Account/Mobile/Email',
		inputPwd: 'Password',
		login: 'Login',
		mobile: 'Mobile',
		newPwd: 'New Password',
		confirmPwd: 'Confirm Password',
		code: 'Code',
		sendCode: 'Send Code',
		changePwd: 'Change Password',
		oldPwd: 'Old Password',
		inputAccountAndPwd: 'Please Enter Account and Password',
		inputAccountOrPwd: 'Please Enter Account or Password',
		inputMobie: 'Please Enter Mobile Phone',
		inputNewPwd: 'Please Enter New Password',
		inputOldPwd: 'Please Enter Old Password',
		inputConfirmPwd: 'Please Enter Confirm Password',
		inputCode: 'Please Enter Code',
		inputPwdRule: 'Please Enter a Comination of 8-15 Digits Including Number,Upper and Lower Letters',
		input: 'Please Enter',
		resetPwdSuc: 'Reset Password Successfully',
		changePwdSuc: 'Change Password Successfully',
		pwdMessage1: 'New and Confirmed Password Should Be Different',
		pwdMessage2: 'New and Confirmed Password Should Be the Same',
		//PageIndex
		LapModule: 'Lease Accounting Module',
		LapModuleStyle: 'psc-font-4 hdp-ut-s',
		exit: 'Exit',
		sureExit: 'Are You Sure to Exit?',
        oldBeginningBalance: 'PV calculated using the original discount rate (lease term shorten only)',

		CONFIG_MANAGE: 'Configuration',
		PERIOD_MANAGE: 'Periods',
		EXCHANGE_RATE: 'Exchange Rate',
		VALUE_SET: 'Value Sets',
		SYSTEM_MAPPING: 'Mapping with Partner',
		LOAN_INTEREST_RATE: 'Discount Rate',
		TAX_RATE: 'Tax Rate',
		RENTAL_ORGANIZATION: 'Lease Organizations',
		DATA_PERMISSION: 'Data Permission',
		ACCOUNT_RULE: 'Account Rules',

		OPERATE_MANAGE: 'Operation',
		EPO_ORDER_LEASING: 'Add Lease Information',
		UPLOAD_OPERATE: 'Upload Lease Items',
		SEARCH_PAGE: 'Query Lease Items',
		FINANCE_INSPECT: 'Check Lease Items',
		FINANCE_REVIEW: 'Approve Lease Items',
		UPLOAD_PO_RECEIVE: 'Actual Payment Upload',
		ACCOUNTING_ENTRIES: 'Query Accounting Entries',
		REPORT_QUERY: 'Query Reports',
		EXEMPT_OPERATION: 'Manage Exemptions',
		LEASE_ANNOTATION: 'Lease Disclosure Appendix',

		ACCOUT_MANAGE: 'My Account',
		USER_INFO: 'User Information',
		CHANGE_PASSWORD: 'Change Password',

		SYSTEM_MANAGE: 'System',
		USER_MANAGE: 'Users',
		ROLE_MANAGE: 'Roles',
		MENU_MANAGE: 'Menus',
		BUTTON_MANAGE: 'Buttons',
		ENUM_MANAGE: 'Data Dictionary',
		LOG_MANAGE: 'Logs',
		
		uploadPage: 'Upload Page',
		operateDetail: 'Detail of the Lease Item',
		//config
		//period
		fiscalYear: 'Fiscal Year',
		startDate: 'Start Date',
		endDate: 'End Date',
		periodNum: 'Period',
		periodStatus: 'Period Status',
		periodStatus1: 'Open',
		periodStatus2: 'Closed',
		periodStatus3: 'Future Periods',
		periodStatusEdit: 'Edit Period Status',
		startMonth: 'Start Month',
		chooseLedger: 'Please Choose the Primary Ledger',
		ledgerNoData: 'The Primary Ledger No Data',
		//Exchange Rates
		operatingUnit: 'Operating Unit',
        ouCode: 'Operation Code',
		currencyFrom: 'Currency From',
		currencyTo: 'Currency To', 
		validityPeriodFrom: 'Validity From',
		validityPeriodTo: 'Validity To',
		exchangeRate: 'Exchange Rate',
		//value set
		valueSetSearch: 'Value Set Name/Code',
		valuesetName: 'Value Set Name',
		valuesetCode: 'Value Set Code',
		createTime: 'Create Time',
		fixedFlag: 'Allow Modification',
		valuesetLineContent: 'Value Set Line Name',
		valuesetLineCode: 'Value Set Line Code',
		valuesetLineProperty: 'Value Set Line Property',
		 //maping
		outsideMapName: 'Mapping Name',
		outsideMapCode: 'Mapping Code',
		inputValue: 'Input Value',
		mapValue: 'Mapping Value',
		inputColumn: 'Input Column',
		mapColumn: 'Mapping Column',
		addInputColumn: 'Add Input Column',
		addMapColumn: 'Add Mapping Column',
		deleteInputColumn: 'Delete Input Column',
		deleteMapColumn: 'Delete Mapping Column',
		noData: 'No data',
		//discount
		discountRateEffectiveFrom: 'Discount Rate Effective From',
		discountRateEffectiveTo: 'Discount Rate Effective To',
		discountRateType: 'Discount Rate Type',
		leaseTermFrom: 'Lease Term From(Exclude)',
		leaseTermTo: 'Lease Term To(Include)',
		discountRateSource: 'Discount Rate Source',
		discountRate: 'Annual Discount Rate',
		borrowingRate: 'Borrowing Rate',
		lendingRate: 'Lending Rate',
		//tax
		taxName: 'Tax Name',
		taxType: 'Tax Type',
		deductible: 'Deductible',
		taxLogic: 'Tax Logic',
		taxRate: 'Tax Rate',
		//dataPermission
		OAAccount: 'OA Account',
		//accountRule
		documentType: 'Voucher Scene Type',
		contentName: 'Voucher Scene',
		sceneType: 'Scene Type',
		dcDirection: 'Direction',
		directionBorrow: 'Dr.',
		directionLoan: 'Cr.',
		titleStage: 'Accounting segment',
		customColumn: 'Custom Columns',
		columnName: 'Column Name',
		customColumnMax: 'Please Confirm Custom Columns Up to 9 Columns',
		//operatePage
		searchOptions: 'Search Options:',
		tableOptions: 'Column Options:',
		showSearch: 'Show Search',
		hiddenSearch: 'Hide Search',
		enterUpload: 'Enter the Upload Interface',
		enterYuanUpload: 'Enter the Metadata Upload Interface ',
		sureAdvanceEnd: 'Sure to Terminate In Advance',
		submit: 'Submit',
		closeBacklog: 'Close To-do',
		advanceEnd: 'Terminate In Advance',
		checkPass: 'Approve',
		reject: 'Reject',
		reviewPass: 'Approve',
		postingErp: 'Gen Accounting Entry',
		closeWaiver: 'Close Exemption',
		surePass: 'Confirm to Pass?',
		operateSuccess: 'Operate Successfully',
		sureCloseBacklog: 'Confirm to Close To-do List?',
		sureReject: 'Confirm to Reject?',
		sureCloseExemption: 'Confirm to Close Exemption',
		sureSubmit: 'Confirm to Submit?',
		rejectReason: 'Reject Reason',
		singleReviewPass: 'Approve One by One',
		chooseChecked: 'Please Choose Checked Lease Item',
		chooseReviewOrPosting: 'Please Choose Reviewed or Posted Lease Item',
		choosePosting: 'Please Choose Posted Lease Item',
		chooseSameOU: 'Please Choose Same OU Lease Item',
		chooseAdvanceEnd: 'Please Choose the Lease Item Whose Transaction Type Is Terminated in Advance',
		chooseSubmitOrPosting: 'Please Choose To-be-submitted or Rejected Lease Item',
		chooseSubmit: 'Please Choose To-be-submitted Lease Item',
		chooseSingle: 'Choose One by One ',
		allPost: 'NO Open Accounting Period',
		onlyRejectChecked: 'Only Checked Items Can be Rejected',
		chooseExemption: 'Please Choose Exempted Lease Item',
		lengthMax40: 'Length Up to 40',
		advanceEndDate: 'Early Termination Date',
		periodName: 'Accounting Period',
		choose: 'Choose',
		//PO receive
		paymentPeriod: 'Payment Period',
		generalLedgerPeriod: 'General Ledger Period',
		submitted: 'Submitted',
		notSubmitted: 'Not Submitted',
		poChargeAccount: 'Bank Clearing Account',
		receiptAmount: 'Actual Payment Amount',
		//account
		postPeriodName: 'Post Accounting Period',
		journalHeaderDesc: 'Journal Header Desc',
		entryAbstract: 'Entry Abstract',
		journalName: 'Journal Name',
		titleGroup: 'Account Code',
		DrContractCurrency: 'Dr.（Contract Currency）',
		CrContractCurrency: 'Cr.（Contract Currency）',
		DrCurrency: 'Dr.（Functional Currency）',
		CrCurrency: 'Cr.（Functional Currency）',
		//report
		reportName: 'Report Name',
		startPeriodName: 'Start Period',
		endPeriodName: 'End Period',
		//lease
		relatedParties: 'Related Parties Included?',
		convertCurrency: 'Currency',
		cashFlowReport: 'Cash Flow Report',
		interestPayment: 'Cash Flow from Financing Activities – Payment of Interest',
		financingActivity: 'Cash Flow from Financing Activities – Payment of Principal',
		operatingCashFlow: 'Operating Cash Flow',
		totalLeaseCashFlow: 'Total Lease Cash Flow',
		cashFlowThisYear: 'Cash Flow This Year',
		cashFlowLastYear: 'Cash Flow Last Year',
		exportLeasePayment: 'Upload Lease Payment',
		groupAssetUseful: 'Group Asset Useful Life Range',
		assetUsefulLifeFrom: 'Asset Useful Life From',
		assetUsefulLifeTo: 'Asset Useful Life To',
		relatedWorkingPaper: 'Related Working Paper',
		assetUsefulLifeRange: 'Asset Useful Life Range',
		leaseAssetLedgerReport: 'Lease Asset Ledger Report',
		groupLeaseLiability: 'Group Lease Liability',
		withinOneYear: 'Within One Year',
		oneToTwo: 'Later Than One Year But Not Later Than Two Years',
		twoToFive: 'Later Than Two Years But Not Later Than Five Years',
		thanFive: 'Later Than Five Years',
		leaseLiabilityBalance: 'Lease Liability Balance',
		thisYearPaymentSchedule: 'This Year Payment Schedule',
		lastYearPaymentSchedule: 'Last Year Payment Schedule',
		leaseLiabilityOne: '  Lease Liability Due Within One Year',
		leaseLiabilityOneOver: 'Lease Liability Due Over One Year',
		assetDisclosure: 'Divisional Report of Asset Disclosure',
		domestic: 'Domestic',
		domesticMillions: 'Domestic(In Millions)',
		overseas: 'Overseas',
		overseasMillions: 'Overseas(In Millions)',
		assetInitialValue: 'Asset Initial Value',
		assetsDepreciation: 'Acc. Depreciation',
		assetNetValue: 'Asset Net Value',
		variablePayment: 'Disclosure of Variable Payment',
    leaseLiability: 'Lease Liability Clearing Account Balance',
		YTDThisYear: 'This Year',
		YTDThisYearMillions: 'This Year(In Millions)',
		YTDLastYear: 'Last Year',
		YTDLastYearMillions: 'Last Year(In Millions)',
		fixedPayment: 'Actual Payment for Non-Exemption Lease',
        variablePayment3: 'Variable Payment',
		variablePayment: 'Actual Payment for Short Term Exemption Lease',
    variablePayment1: 'Actual Payment for Low Value Exemption Lease',
    variablePayment2: 'Actual Payment for Variable Exemption Lease',
		leasePayment: 'Lease Payment',
		percentage: 'Percentage(Variable/Lease Total Payment)',
		cashFlowDisclosureReport: 'Cash Flow Disclosure Report',
		nameWidth: '400',
		noDataSearchFirst: 'No Data, Please Search First',
		requirePeriodName: 'Accounting Period Required',
		requireSupplier: 'Related Parties Included Required',
		inputRequire: 'Please Enter the Required Fields',
		//system
		userName: 'User Name',
		roleName: 'Role Name',
		email: 'Email',
		userAccount: 'Account',
		mobileNumber: 'Mobile',
		password: 'Password',
		createBy: 'Created By',
		updateBy: 'Updated By',
		updateTime: 'Updated Time',
		roleCode: 'Role Code',
		save: 'Save',
		roleInfo: 'Role Info',
		relatedUsers: 'Related Users',
		choose: 'Choose',
		relatedResources: 'Related Resources',
		chooseBtn: 'Choose Button',
		chooseAll: 'Choose All',
		chooseMenu: 'Please Choose the Menu First',
		menuNoBtn: 'There Is No Optional Button on This Menu',
		roleNameExist: 'The Role Name Already Exists',
		saveSuccess: 'Save Successfully',
		menuNameOrCode: 'Menu Name/Menu Code',
		menuName: 'Menu Name',
		menuCode: 'Menu Code',
		menuLink: 'Menu Link',
		menuType: 'Menu Type',
		menuParentCode: 'Parent Menu Code',
		menuParentName: 'Parent Menu Name',
		menuSortNum: 'Order',
		menuIcon: 'Icon',
		firstMenu: 'First Menu',
		secondMenu: 'Second Menu',
		buttonName: 'Button Name',
		buttonCode: 'Button Code',
		buttonType: 'Button Type',
		addItem: 'Add Item',
		dictionaryName: 'Dictionary Name',
		chooseDic: 'Please choose the data dictionary first',
		logType: 'Log Type',
		time: 'Time',
		logResultMessage: 'Log Result Message',
		clientIp: 'IP Address',

		navDicData: 'RENTAL_ITEM_DETAIL_NAV_EN',
		documentTypeValueset: 'DOCUMENT_TYPE_EN',
		titileTypeValueset: 'SUBJECT_TYPE_EN',
		subentryLineValueset: 'SUBENTRY_LINE_TYPE_EN',

    94:'TO DO',
    95:'SUBMITTED',
    96:'CHECKED',
    97:'APPROVED',
    98:'POSTED',
    99:'LEASE COMPLETED',
    100:'RECALLED',
    101:'REVERSED',
    102:'REVALUATED',
    103:'EARLY TERMINATED',
    104:'PARTIALLY CANCELLED',
    105:'REJECTED',
    112:'CLOSED',
    118:'LEASE TERM SHORTENED',
    119:'TO BE SUBMITTED',
    129:'EXEMPTED',
    130:'EXEMPTION CLOSED',
    // 94:'To-do',
    // 95:'Submitted',
    // 96:'Checked',
    // 97:'Reviewed',
    // 98:'Posted',
    // 99:'Terminated normally',
    // 100:'Withdrawn',
    // 101:'Revaluated',
    // 102:'Revalued',
    // 103:'Early Canceled',
    // 104:'Partially Canceled',
    // 105:'Rejected',
    // 112:'Closed',
    // 118:'Lease Term Shortened',
    // 119:'To be submitted',
    // 129:'Exempted',
    // 130:'Exemption Closed',
	// },
}

const el = {
	colorpicker: {
		confirm: 'OK',
		clear: 'Clear'
	},
	datepicker: {
		now: 'Now',
		today: 'Today',
		cancel: 'Cancel',
		clear: 'Clear',
		confirm: 'OK',
		selectDate: 'Select date',
		selectTime: 'Select time',
		startDate: 'Start Date',
		startTime: 'Start Time',
		endDate: 'End Date',
		endTime: 'End Time',
		prevYear: 'Previous Year',
		nextYear: 'Next Year',
		prevMonth: 'Previous Month',
		nextMonth: 'Next Month',
		year: '',
		month1: 'January',
		month2: 'February',
		month3: 'March',
		month4: 'April',
		month5: 'May',
		month6: 'June',
		month7: 'July',
		month8: 'August',
		month9: 'September',
		month10: 'October',
		month11: 'November',
		month12: 'December',
	  // week: 'week',
	  weeks: {
	  	sun: 'Sun',
	  	mon: 'Mon',
	  	tue: 'Tue',
	  	wed: 'Wed',
	  	thu: 'Thu',
	  	fri: 'Fri',
	  	sat: 'Sat'
	  },
	  months: {
	  	jan: 'Jan',
	  	feb: 'Feb',
	  	mar: 'Mar',
	  	apr: 'Apr',
	  	may: 'May',
	  	jun: 'Jun',
	  	jul: 'Jul',
	  	aug: 'Aug',
	  	sep: 'Sep',
	  	oct: 'Oct',
	  	nov: 'Nov',
	  	dec: 'Dec'
	  }
	},
	select: {
		loading: 'Loading',
		noMatch: 'No matching data',
		noData: 'No data',
		placeholder: 'Select'
	},
	cascader: {
		noMatch: 'No matching data',
		loading: 'Loading',
		placeholder: 'Select'
	},
	pagination: {
		goto: 'Go to',
		pagesize: '/page',
		total: 'Total {total}',
		pageClassifier: ''
	},
	messagebox: {
		title: 'Message',
		confirm: 'OK',
		cancel: 'Cancel',
		error: 'Illegal input'
	},
	upload: {
		deleteTip: 'press delete to remove',
		delete: 'Delete',
		preview: 'Preview',
		continue: 'Continue'
	},
	table: {
		emptyText: 'No Data',
		confirmFilter: 'Confirm',
		resetFilter: 'Reset',
		clearFilter: 'All',
		sumText: 'Sum'
	},
	tree: {
		emptyText: 'No Data'
	},
	transfer: {
		noMatch: 'No matching data',
		noData: 'No data',
	  	titles: ['List 1', 'List 2'], // to be translated
	  	filterPlaceholder: 'Enter keyword', // to be translated
	  	noCheckedFormat: '{total} items', // to be translated
	  	hasCheckedFormat: '{checked}/{total} checked' // to be translated
	}
}

export {m, el}



// WEBPACK FOOTER //
// ./src/assets/lang/en_US.js